export const POINTER_WIDTH = 6;
export const POINTER_HEIGHT = 3;
export const BORDER_RADIUS = 6;
export const BUBBLE_HEIGHT = 30;
export const MARKERTEXT_WIDTH = 130;
export const CHART_RIGHT_PADDING = 10;
export const BUBBLE_VERTICAL_GAP = 6;
